var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0c.66 0 1.203.496 1.277 1.136l.009.15v6.428h6.428a1.286 1.286 0 0 1 .15 2.563l-.15.009h-6.428v6.428a1.286 1.286 0 0 1-2.563.15l-.009-.15v-6.428H1.286a1.286 1.286 0 0 1-.15-2.563l.15-.009h6.428V1.286C7.714.576 8.29 0 9 0Z",
    fill: "#2E3131"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.23cabf283cae32f2db5fe3764a218102.svg";